import {
  AdminLayout,
  useLocalStorage,
  useSource,
  useTranslation,
} from "@opendash/core";
import { AdminToolbar } from "@opendash/ui";
import { Checkbox } from "antd";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { ExecutionsTable } from "../../features/schedules";

export const ScheduleSourcePage = observer(() => {
  const t = useTranslation();
  const [source] = useSource();
  const [showChildren, setShowChildren] = useLocalStorage(
    "openservice:show-children-in-schedule-table",
    false
  );

  return (
    <AdminLayout contentPadding>
      <AdminToolbar
        title={t("maintenance:schedule.source.executions.headline", {
          source: source.name,
        })}
        actions={[
          <Checkbox
            checked={showChildren}
            onChange={(e) => {
              setShowChildren(e.target.checked);
            }}
            key="filter.children"
          >
            {t("maintenance:schedule.source.actions.filter.children")}
          </Checkbox>,
        ]}
      />
      <div className="od-page-main">
        <ExecutionsTable showChildren={showChildren} />
      </div>
    </AdminLayout>
  );
});
